export const GET_MY_TEAM = 'GET_MY_TEAM';
export const UPDATE_TEAM_NAME = 'UPDATE_TEAM_NAME';

export const UPDATE_EMAIL = 'UPDATE_EMAIL';



// WEBPACK FOOTER //
// ./src/data/constants/profile-constants.jsx